import React from 'react';
import { CardsSection } from 'components/layout/Section/CardsSection';
import { SignContractCard } from '../cards/SignContractCard';
import { useTranslation } from 'react-i18next';
import { NsKey } from 'enums/NsKey';
import { SignMandateCard } from '../cards/SignMandateCard';
import { DocumentsCard } from '../documents';

/**
 * Component for handling contract and mandate signatures
 */
export const ContractSignature: React.FC = () => {
  const { t } = useTranslation(NsKey.Contractualization)
  return (
    <CardsSection title={t('CONTRACTUALIZATION.CARDS.SIGN_CONTRACT_SECTION')}>
      <div className='grid grid-cols-2 gap-4'>
        {/* SEPA Mandate signature card - only shown if SEPA is activated and mandate exists */}
        <SignMandateCard />

        {/* Contract signature card */}
        <SignContractCard />

        {/* Documents overview card */}
        <DocumentsCard className='col-span-2' />
      </div>
    </CardsSection>
  );
};
